<template>
    <v-card class="mx-auto" min-width="500">

        <v-card-title class="text-h6 font-weight-regular justify-space-between">
        <span>Νέα κίνηση συμψηφισμού</span>
        </v-card-title>

        <v-dialog v-model="selectAccountDialog" max-width="400">
            <v-card class="ma-4" max-width="350" v-bind:key="account.id" v-for="account in selectAccountDialogEntries">
                <v-card-title class="text-wrap">
                    <p>{{account.name}}</p>
                </v-card-title>
              
                <v-card-subtitle>{{ `ΑΦΜ: ${account.tax_registration_number || '-'}` }}</v-card-subtitle>
              
                <v-card-text>
                    <v-container>
                        <v-row>
                            <div>{{account.city}} {{account.zipcode}}</div>
                        </v-row>
                        <v-row>
                            <div>{{account.address}}</div>
                        </v-row>
                        <v-row>
                            <div>{{account.telephone}}</div>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="updateAccount(selectAccountDialogShownFor, account); closeSelectAcountDialog();">ΕΠΙΛΟΓΗ</v-btn>
                </v-card-actions>
            </v-card>
     
        </v-dialog>
        <!-- ΒΑΣΙΚΑ ΣΤΟΙΧΕΙΑ -->

        <v-window v-model="step">
            <v-window-item :value="0">
                <v-card-text>
                    <h3 class="text-h6 font-weight-light mb-4">Βασικά στοιχεία</h3>
                    
                    <v-select 
                        v-bind:items="incomeDocumentTypes" 
                        v-model="selectedIncomeDocumentType"
                        return-object
                        
                        item-text="description" 
                        label="Είδος παραστατικού είσπραξης"
                        v-bind:error-messages="allerrors.document_type_id">
                    </v-select>

                    <v-select 
                        v-show="selectedIncomeDocumentType.series.length > 1 || (selectedIncomeDocumentSeries.name && selectedIncomeDocumentselectedIncomeDocumentSeries.name.length > 0)"
                        v-bind:items="selectedIncomeDocumentType.series"
                        v-model="selectedIncomeDocumentSeries"
                        return-object
                        item-text="name"
                        item-value="id" 
                        label="Σειρά παραστατικού είσπραξης"
                        v-bind:error-messages="allerrors.document_series">
                    </v-select>

                    <v-select 
                        v-bind:items="paymentDocumentTypes" 
                        v-model="selectedPaymentDocumentType"
                        return-object
                        
                        item-text="description" 
                        label="Είδος παραστατικού πληρωμής"
                        v-bind:error-messages="allerrors.document_type_id">
                    </v-select>

                    <v-select 
                        v-show="selectedPaymentDocumentType.series.length > 1 || (selectedPaymentDocumentSeries?.name && selectedPaymentDocumentSeries.name.length > 0)"
                        v-bind:items="selectedPaymentDocumentType.series"
                        v-model="selectedPaymentDocumentSeries"
                        return-object
                        item-text="name"
                        item-value="id" 
                        label="Σειρά παραστατικού πληρωμής"
                        v-bind:error-messages="allerrors.document_series">
                    </v-select>



                    <v-menu
                        v-model="menu2"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="document_issue_date"
                                label="Ημερομηνία έκδοσης"
                                append-icon="mdi-calendar"
                                readonly
                                v-bind="attrs"
                                v-on="on">
                            </v-text-field>
                        </template>
                        <v-date-picker
                            v-model="document_issue_date"
                            @input="menu2 = false">
                        </v-date-picker>
                    </v-menu>

                </v-card-text>
            </v-window-item>






            <!-- ΠΕΛΑΤΗΣ -->

            <v-window-item :value="1">
                <v-card-text>
                    <h3 class="text-h6 font-weight-light mb-4"> Οικονομικά στοιχεία</h3>

                    <v-select 
                        v-bind:items="accounts" 
                        v-model="incomeAccount"
                        return-object

                        item-text="name" 
                        label="Είσπραξη από"
                        v-bind:error-messages="allerrors.payment_type_id">
                    </v-select>

                    <v-select 
                        v-bind:items="accounts"
                        v-model="paymentAccount"
                        return-object

                        item-text="name" 
                        label="Πληρωμή σε"
                        v-bind:error-messages="allerrors.payment_type_id">
                    </v-select>

                    <v-select 
                        v-bind:items="paymentTypes" 
                        v-model="selectedPaymentType"
                        return-object

                        item-text="description" 
                        label="Τρόπος πληρωμής"
                        v-bind:error-messages="allerrors.payment_type_id">
                    </v-select>

                    <vuetify-money
                        v-model="document_gross_value"
                        label="Μικτό ποσό"
                        v-bind:options="moneyFieldOptions">
                    </vuetify-money>

                </v-card-text>

            </v-window-item>


            <v-window-item :value="2">
                <v-card-text>
                    <h3 class="text-h6 font-weight-light mb-4">Παρατηρήσεις - Σχόλια</h3>

                    <v-textarea
                        v-model="comments"
                        label="Σχόλια">
                    </v-textarea>
                    
                </v-card-text>
            </v-window-item>

            <v-window-item :value="3">
                <v-card-text>
                    <h3 class="text-h6 font-weight-light mb-4">Σύνοψη παραστατικού</h3>
                    
                    <v-text-field
                        readonly 
                        v-model="selectedIncomeDocDetails" 
                        label="Παραστατικό εισπραξης">
                    </v-text-field>

                    <v-text-field
                        readonly 
                        v-model="selectedPaymentDocDetails" 
                        label="Παραστατικό πληρωμής">
                    </v-text-field>

                    <v-text-field
                        readonly 
                        v-model="document_issue_date" 
                        label="Ημερομηνία">
                    </v-text-field>

                    <v-text-field
                        readonly 
                        v-model="incomeAccount.name" 
                        label="Είσπραξη από">
                    </v-text-field>

                    <v-text-field
                        readonly 
                        v-model="paymentAccount.name" 
                        label="Πληρωμή πρός">
                    </v-text-field>

                    <v-text-field
                        readonly 
                        v-model="document_gross_value" 
                        label="Συνολικό ποσό">
                    </v-text-field>

                    <v-text-field
                        readonly 
                        v-model="selectedPaymentType.description" 
                        label="Τρόπος πληρωμής">
                    </v-text-field>

                    <div class="text-center">
                        <v-btn 
                            color="success" 
                            @click="saveDocument" 
                            v-bind:loading="saveDocumentButtonDisabled">
                            ΑΠΟΘΗΚΕΥΣΗ
                        </v-btn>
                    </div>
                </v-card-text>

            </v-window-item>
        </v-window>

        <v-card-actions>
            <v-btn
                v-bind:disabled="step <= 0"
                text
                v-on:click="step--"
                color="primary">
                ΠΙΣΩ
            </v-btn>
            <v-spacer></v-spacer>
            <v-item-group
                v-model="step"
                class="text-center"
                mandatory>
                <v-item
                        v-for="n in totalSteps"
                        v-bind:key="`btn-${n}`"
                        v-slot="{ active, toggle }">
                    <v-btn
                        v-bind:input-value="active"
                        icon
                        dense
                        x-small
                        
                        @click="toggle">
                        <v-icon>mdi-record</v-icon>
                    </v-btn>
                </v-item>
            </v-item-group>

            <v-spacer></v-spacer>
            <v-btn
                v-bind:disabled="(step >= totalSteps - 1) || (stepCompleted == false)"
                color="primary"
                depressed
                @click="step++;">
                ΕΠΟΜΕΝΟ
            </v-btn>
        </v-card-actions>


    </v-card>

</template>

<script>
import goTo from 'vuetify/lib/services/goto'

export default {
    data () {
        return {
            accounts: [],
            
            incomeAccount: {},
            paymentAccount: {},

            moneyFieldOptions: {
                locale: "el-GR",
                prefix: "€",
                suffix: "",
                length: 8,
                precision: 2
            },

            step: 0,
            totalSteps: 4,
            menu2: false,
            saveDocumentButtonDisabled: false,
            
            allerrors : {
                customer: {},
             },

            customer: {
                country: {},
                tax_office: { },

            },

            incomeDocumentTypes: [],
            paymentDocumentTypes: [],
            
            documentSeries: [],

            paymentTypes: [],

            selectedIncomeDocumentType: {
                series: []
            },
            
            selectedPaymentDocumentType: {
                series: []
            },

            selectedIncomeDocumentSeries: {},
            selectedPaymentDocumentSeries: {},


            selectedPaymentType: {},

            document_number: '',
            document_issue_date: '',
            document_gross_value: '',



            if_payback: false,

            comments: '',

            menu2: false,

            selectAccountDialog: false,
            selectAccountDialogEntries: [],
            selectAccountDialogShownFor: '',


        }
    },

    created() {
        this.initialize()
    },

    watch: {
        selectedIncomeDocumentType: function (val) {
            this.document_number = ''
            this.selectedIncomeDocumentSeries = {}


            if (this.selectedIncomeDocumentType.series.length == 1)
                this.selectedIncomeDocumentSeries = this.selectedIncomeDocumentType.series[0]


        },

        selectedPaymentDocumentType: function (val) {
            this.document_number = ''
            this.selectedPaymentDocumentSeries = {}


            if (this.selectedPaymentDocumentType.series.length == 1)
                this.selectedPaymentDocumentSeries = this.selectedPaymentDocumentType.series[0]


        },


    },

    computed: {
        selectedIncomeDocDetails () {
            if (this.selectedIncomeDocumentType.id && this.selectedIncomeDocumentSeries.id)
                return `${this.selectedIncomeDocumentType.description} ${this.selectedIncomeDocumentSeries.name}`

            return ''
        },

        selectedPaymentDocDetails () {
            if (this.selectedPaymentDocumentType.id && this.selectedPaymentDocumentSeries.id)
                return `${this.selectedPaymentDocumentType.description} ${this.selectedPaymentDocumentSeries.name}`

            return ''
        },

        selectedDocumentDescription () { 
            if (this.document_type_id && this.documentTypes.length > 0)
                return this.documentTypes.find(x => x.id == this.document_type_id).description

            return ''
        },

        stepCompleted() {
            switch (this.step) {
                case 0:
                    if ((this.selectedIncomeDocumentType.id ?? 0) > 0 == false)
                        return false

                    if ((this.selectedPaymentDocumentType.id ?? 0) > 0 == false)
                        return false

                    if ((this.selectedIncomeDocumentSeries.id ?? 0) > 0 == false)
                        return false


                    if ((this.selectedPaymentDocumentSeries.id ?? 0) > 0 == false)
                        return false


                    
                    if (!this.document_issue_date)
                        return false
                    
                    break

                case 1:
                    if ((this.document_gross_value ?? 0 > 0) == false)
                        return false

                    if ((this.selectedPaymentType.id ?? 0 > 0) == false)
                        return false

                    if ((this.incomeAccount.id ?? 0 > 0) == false)
                        return false

                    if ((this.paymentAccount.id ?? 0 > 0) == false)
                        return false


                    return true

                default:
                    return true
            }
        },

        customerNotEditable() {
            return (this.customer.id ?? 0) > 0
        }
            
    },


    methods: {
        initialize() {
            this.$store.dispatch('currentUser/getCurrentUser')
            
            // this.document_issue_date = new Date().toISOString().slice(0, 10)

            const dateAthens = new Intl.DateTimeFormat('en-CA', {
                timeZone: 'Europe/Athens',
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
            }).format(new Date());

            this.document_issue_date = dateAthens;

            axios.all([
                axios.get('/api/document-types/income'),
                axios.get('/api/document-types/payment'),
                axios.get('/api/accounts'),
                axios.get('/api/tax-authority/payment-types'),
            ]).then(
                axios.spread(
                (
                    incomeDocumentTypesResponse, 
                    paymentDocumentTypesResponse,
                    accountsResponse,
                    paymentTypesResponse,
                ) => {
                    this.incomeDocumentTypes = incomeDocumentTypesResponse.data.sort((a, b) => a.description.localeCompare(b.description))
                    this.paymentDocumentTypes = paymentDocumentTypesResponse.data.sort((a, b) => a.description.localeCompare(b.description))
                    
                    this.paymentTypes = paymentTypesResponse.data.filter(x => x.flag_credit == false)

                    this.accounts = accountsResponse.data;
            })).catch(error => { console.log(error) })
        },

        clearCustomerFields() {
            this.customer = {
                country: {},
                tax_office: { },

            }

            this.selectedContract = {}
        },

        saveDocument() {
            this.saveButtonDisabled = true;

            let requestBody = {
                income_document_type_id: this.selectedIncomeDocumentType.id,
                income_document_series_id: this.selectedIncomeDocumentSeries.id,

                payment_document_type_id: this.selectedPaymentDocumentType.id,
                payment_document_series_id: this.selectedPaymentDocumentSeries.id,


                issue_date: this.document_issue_date,

                income_account_id: this.incomeAccount.id,
                payment_account_id: this.paymentAccount.id,

                gross_value: this.document_gross_value,

                payment_type_id: this.selectedPaymentType.id,

                comments: this.comments
            }

            axios.post('/api/offset-transaction', requestBody)
            .then(_ => { 
                this.$router.push({ name: 'home' })
            })
            .catch(error => { 
                console.log(error)
                if (error.response && error.response.data) {
                    if (error.response.data.errors) {
                        const errs = { customer: {} }
                        for (const [key, val] of Object.entries(error.response.data.errors)) {
                            const parts = key.split('.')
                            if (parts.length === 2) {
                                if (!errs[parts[0]]) errs[parts[0]] = {}
                                errs[parts[0]][parts[1]] = val
                            } else {
                                errs[key] = val
                            }
                        }
                        this.allerrors = errs
                        const messages = Object.values(error.response.data.errors).flat().join('<br>')
                        this.$swal({ icon: 'error', title: 'Σφάλμα', html: messages })
                    } else if (error.response.data.message) {
                        this.$swal({ icon: 'error', title: 'Σφάλμα', text: error.response.data.message })
                    }
                }
              })
            .finally( () => { this.saveButtonDisabled = false })
        },

        async searchAccountByTaxRegistrationNumber(accountPropertyName) {
            let needle = this[accountPropertyName].tax_registration_number
            let response = await axios.get(`/api/accounts/search/tax-registration-number/${needle}`)

            if (response.data.length == 1) {
                let account = response.data[0]

                this.updateAccount(accountPropertyName, account)
                
            } else if (response.data.length > 1) {
                this.selectAccountDialogEntries = response.data
                this.selectAccountDialogShownFor = accountPropertyName
                this.selectAccountDialog = true
            }
            
        },

        async searchAccountByName(accountPropertyName) {
            let needle = this[accountPropertyName].name
            let response = await axios.get(`/api/accounts/search/name/${needle}`)

            if (response.data.length == 1)
                this.updateAccount(accountPropertyName, response.data[0])
            else if (response.data.length > 1) {

                this.selectAccountDialogEntries = response.data
                this.selectAccountDialogShownFor = accountPropertyName
                this.selectAccountDialog = true
            }
        },

        closeSelectAcountDialog() {
            this.selectAccountDialog = false
            this.selectAccountDialogEntries = []
            this.selectAccountDialogShownFor = null
        },

        updateAccount(accountPropertyName, data) {
            this[accountPropertyName] = {
                id: data.id,
                address : data.address,
                name : data.name,
                city : data.city,
                telephone : data.telephone,
                fax : data.fax,
                email : data.email,
                //country_id : data.country_id,
                mobile : data.mobile,
                tax_registration_number: data.tax_registration_number,
                zipcode: data.zipcode,
                tax_office: data.tax_office ?? { } ,
                country: data.country ?? { },
                contracts: data.contracts
                // tax_office: data.tax_office
            }
        }
            //.catch(error => { console.log(error) })
    }
}
</script>

<style scoped>

</style>